import React, { useState, useEffect } from 'react';
import { Tooltip as ChakraTooltip, Box } from '@chakra-ui/react';

interface TooltipProps {
    text: string;
    enabled?: boolean;
    showArrow?: boolean;
    children: React.ReactElement;
}

export const Tooltip: React.FC<TooltipProps> = ({ text, enabled = true, showArrow = true, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = () => {
            setIsOpen(false);
        };

        if (isOpen) {
            document.addEventListener('click', handleClickOutside);
            return () => document.removeEventListener('click', handleClickOutside);
        }
    }, [isOpen]);

    if (!enabled) {
        return children;
    }

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsOpen(!isOpen);
    };

    return (
        <ChakraTooltip.Root open={isOpen} onOpenChange={(details) => setIsOpen(details.open)}>
            <ChakraTooltip.Trigger asChild>
                <Box onClick={handleClick} display="inline-flex" alignItems="center">
                    {children}
                </Box>
            </ChakraTooltip.Trigger>
            <ChakraTooltip.Positioner>
                <ChakraTooltip.Content
                    p={4}
                    color="white"
                    background="gray.700"
                    style={{ ['--tooltip-bg' as string]: '#3f3f46' }}
                    fontSize="md"
                    letterSpacing="wider"
                    lineHeight="moderate"
                >
                    {showArrow && (
                        <ChakraTooltip.Arrow>
                            <ChakraTooltip.ArrowTip />
                        </ChakraTooltip.Arrow>
                    )}
                    {text}
                </ChakraTooltip.Content>
            </ChakraTooltip.Positioner>
        </ChakraTooltip.Root>
    );
};
